export class VoiceOrderItemDto {
  id?: number
  itemName: string;
  quantity: number;
  price: number;
}